// extracted by mini-css-extract-plugin
export default {"tickerLabel":"Portfolio_tickerLabel__7KgjT"};